import { Component, Inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { Toast } from "primeng/toast";
import { LoggingService } from "./services/logging.service";
import { checkUrl, isCookieAccepted } from "./global";
import { RoutingNames as routes } from "./shared/enums/routes-names";
import { IAuthenticationService } from "./shared/interfaces/iauthentication-service";
import { environment } from "src/environments/environment";
import Hotjar from "@hotjar/browser";
import { UpToDateBuildService } from "./b2b/ops/shared/services/up-to-date.service";
import { CookieConsentComponent } from "./shared/components/cookie-consent/cookie-consent.component";
import { LoadingCyberaComponent } from "./shared/components/loading-cybera/loading-cybera.component";
import { AuthenticationServiceProvider } from "./services/AuthenticationServiceProvider";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  imports: [RouterOutlet, Toast, CookieConsentComponent, LoadingCyberaComponent],
})
export class AppComponent {
  public constructor(
    private readonly router: Router,
    public upToDateBuildService: UpToDateBuildService, // init service
    @Inject(AuthenticationServiceProvider)
    public authService: IAuthenticationService,
    private readonly loggingService: LoggingService,
    // init msalBroadcastService - to get the correct value from "inProgress$" in guards then
    private readonly msalBroadcastService: MsalBroadcastService,
  ) {
    this.loggingService.initAppInsights(this.router);
    this.initHotjar();
  }

  public get showCookieConsent(): boolean {
    return (
      !isCookieAccepted() &&
      !checkUrl(routes.B2B_OPS_COMPLAINT_DOCUMENT) &&
      !checkUrl(routes.COMPLAINT_POA)
    );
  }

  private initHotjar() {
    if (!environment.HOTJAR_ID) return;
    Hotjar.init(environment.HOTJAR_ID, 6, {
      nonce: "QuhY5YTE1wnDLX2hMQ3r6Qn/[9:v",
    });
  }
}
